import React from 'react';
import { useParams } from 'react-router-dom';

import NewsletterStructuredEditor from '../../../components/Admin/Newsletter/NewsletterStructuredEditor.module';

function NewsletterEditView() {
  const { id } = useParams<{ id: string }>();
  return <NewsletterStructuredEditor newsletterId={id} />;
}

export default NewsletterEditView;